import { Reveal } from "./Reveal";

const HERBS_IMG =
  "https://images.unsplash.com/photo-1768729340164-7d83fe18384d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHx0dXJtZXJpYyUyMHBvd2RlciUyMHNwaWNlcyUyMGJyYXNzJTIwYXl1cnZlZGF8ZW58MHx8fHwxNzkxMjM4OTE2fDA&ixlib=rb-4.1.0&q=85";

export const Philosophy = () => (
  <section
    id="philosophy"
    data-testid="philosophy-section"
    className="mx-auto max-w-[1400px] px-6 py-28 lg:px-12 lg:py-40"
  >
    <div className="grid items-center gap-16 lg:grid-cols-12">
      <div className="lg:col-span-7">
        <Reveal>
          <p
            data-testid="philosophy-overline"
            className="text-[11px] font-medium uppercase tracking-[0.4em] text-accent"
          >
            The Ayurenew Philosophy
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2
            data-testid="philosophy-heading"
            className="mt-8 font-serif text-4xl font-light leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl"
          >
            Ancient Panchakarma therapies, <em className="text-accent">modern touch</em> — healing
            precisely matched to <em className="text-accent">your needs</em>.
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-10 max-w-xl text-base font-light leading-relaxed text-muted-foreground lg:text-lg">
            Rooted in millennia of Ayurvedic science and guided by contemporary, personal care,
            Ayurenew brings the depth of authentic Panchakarma into modern living — gently,
            intelligently, and always built around you.
          </p>
        </Reveal>
      </div>
      <div className="lg:col-span-5">
        <Reveal delay={0.15}>
          <div className="group overflow-hidden border border-border/60">
            <img
              src={HERBS_IMG}
              alt="Ayurvedic herbs and warm tea on wood"
              className="aspect-[4/5] w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
